._deprecationOverlayModalPanel_11nvr_1 ._control-message-modal-title_11nvr_1 {
  padding-right: 0; }

._deprecationOverlayModalPanel_11nvr_1 ._control-message-modal-content_11nvr_4 {
  margin-bottom: 0; }
